import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'schoolYear' })

export class SchoolYearPipe implements PipeTransform {
    transform(value: string | undefined | null) {
        if (value == null || value == '') return '';
        if (!(typeof value === 'string')) return value;
        return '20' + value.substring(0, 2) + ' - ' + '20' + value.substring(2);

        // if (value.length === 8) return value.slice(0, 4) + ' - ' + value.slice(4);
        // if (value.length === 4) return '20' + value.slice(0,2) + ' - ' + '20' + value.slice(2);
        // return value;
    };
}